import type { NotificationType } from './types';

export const TIME = 3000;

export const INFO: NotificationType = 'info';

export const SUCCESS: NotificationType = 'success';

export const WARNING: NotificationType = 'warning';

export const ERROR: NotificationType = 'error';
